<template>
    <div>
        <ProfileBlock :title="$t('components.emails_edit.block_name')">
            <div class="divide-y">
                <!-- primary phone -->
                <div class="py-3" v-if="primary">
                    <div class="flex flex-row justify-between items-center">
                        <div class="flex-1 font-semibold truncate">
                            {{ primary.address }}
                        </div>
                        <div class="text-orange flex items-center">
                            <span class="material-icons-outlined">star</span>
                        </div>
                    </div>
                </div>

                <!-- filtered_emails (non primary) -->
                <div
                    v-for="email in filtered_emails"
                    :key="email.id"
                    class="py-3"
                >
                    <div class="flex flex-row justify-between items-center">
                        <div class="flex-1 truncate">
                            {{ email.address }}
                        </div>
                        <div
                            class="hover:text-red flex items-center"
                            @click="destroy({ id: email.id })"
                        >
                            <!-- delete -->
                            <span class="material-icons-outlined mr-1"
                                >delete</span
                            >
                        </div>
                        <div
                            class="hover:text-orange flex items-center"
                            @click="
                                set_primary({
                                    id: email.id,
                                    is_primary: true
                                })
                            "
                        >
                            <!-- make primary -->
                            <span class="material-icons-outlined">grade</span>
                        </div>
                    </div>
                </div>
            </div>

            <div></div>
            <!-- this empty div should be here, do not remove it! -->
            <template v-slot:block-link>
                <div @click="openModal()">
                    {{ $t("components.emails_edit.add_new_button") }}
                </div>
            </template>
        </ProfileBlock>

        <Modal
            :title="$t('components.emails_edit.modal.block_name')"
            ref="modal"
        >
            <FormulateForm
                id="add-new-phone-form"
                v-model="form"
                @submit="submit"
            >
                <FormulateInput
                    type="email"
                    name="address"
                    :label="$t('components.emails_edit.modal.address_label')"
                    validation="required|email"
                />
                <FormulateInput
                    type="checkbox"
                    :label="$t('components.emails_edit.modal.primary_label')"
                    name="is_primary"
                />
            </FormulateForm>
            <template v-slot:actions>
                <button type="submit" form="add-new-phone-form">
                    {{ $t("components.emails_edit.modal.save_button") }}
                </button>
                <button @click="closeModal()" class="text-gray-400">
                    {{ $t("components.emails_edit.modal.cancel_button") }}
                </button>
            </template>
        </Modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/common/Modal";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "EmailsEdit",
    data() {
        return {
            form: {}
        };
    },
    methods: {
        submit() {
            this.create(this.form).then(() => {
                this.$toast.success(
                    this.$t("components.emails_edit.created_message").toString()
                );
                this.closeModal();
            });
        },
        set_primary({ id }) {
            this.update({ id, is_primary: true }).then(() => {
                this.$toast.success(
                    this.$t(
                        "components.emails_edit.primary_updated_message"
                    ).toString()
                );
            });
        },
        destroy({ id }) {
            this.delete({ id }).then(() => {
                this.$toast.success(
                    this.$t("components.emails_edit.deleted_message").toString()
                );
            });
        },
        openModal() {
            this.$refs.modal.open();
        },
        closeModal() {
            this.form = {};
            this.$refs.modal.close();
        },
        ...mapActions({
            fetch: "profile/emails/fetch",
            create: "profile/emails/create",
            update: "profile/emails/update",
            delete: "profile/emails/delete"
        })
    },
    computed: {
        filtered_emails() {
            return this.emails.filter(email => !email.is_primary);
        },
        ...mapGetters({
            emails: "profile/emails/emails",
            primary: "profile/emails/primary"
        })
    },
    mounted() {
        this.fetch();
    },
    components: { Modal, ProfileBlock }
};
</script>

<style scoped></style>
